<template>
<el-container>
  <publicHeader :currencyShow="currencyShow" @hotelLanguage="hotelLanguage" v-if="common.isMobile() === false"></publicHeader>
  <div style="clear:both;height: 60px;" v-if="common.isMobile() === false"></div>
  <el-main :class="{'main-mobile': common.isMobile() === true}">
      <div class="main" v-if="common.isMobile() === false">
        <div class="waiting-text-one" style="line-height: 160px;">{{$t('youBookingIsConfirming')}}</div>
        <div class="waiting-text-two" style="line-height: 160px;">{{$t('pleaseDoNotCLoseYourBrowserClickBackButton')}}</div>
        <div class="demo"><img src="https://res.roompai.com/static/img/loading.gif" alt=""></div>
      </div>
      <div class="main" v-else>
        <div class="demo"><img src="https://res.roompai.com/static/img/loading.gif" alt="" style="width: 53px;height: 40px;"></div>
      </div>
      <frameNetwork :frameNetworkDialog="frameNetworkDialog"></frameNetwork>
  </el-main>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { orderPayment } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import frameNetwork from '@/components/public/frameNetwork'
export default {
  name: 'Waiting',
  components: {
    publicFooter,
    publicHeader,
    frameNetwork
  },
  data () {
    return {
      currencyShow: false, // 币种是否显示
      language: this.common.languageSet(this),
      frameNetworkDialog: false, // 网络异常
      source: 'roompai',
      conver: ''
    }
  },
  created () {
    var params = this.$route.params
    var orderData = localStorage.getItem('orderData')
    if (JSON.stringify(params) === '{}' && orderData !== '{}') {
      params = JSON.parse(orderData)
    }

    if (params.conver === 1 || params.conver === '1') {
      this.conver = params.conver
    } else if (this.common.linkQuerys.conver === 1 || this.common.linkQuerys.conver === '1') {
      this.conver = this.common.linkQuerys.conver
    }

    if (this.common.linkQuerys.paymentOn === 'pingpong') {
      this.pingpongJumpOver()
    } else if (params.paymentSkipUrl === '' || params.paymentSkipUrl === null || params.paymentSkipUrl === undefined) {
      this.waitingShow()
    } else {
      var paymentList = document.querySelectorAll('#paymentALink')
      if (paymentList.length > 0) {
        paymentList[0].remove()
      }
      // if (params.paymentOn === 'wechat') {
      //   document.querySelector("meta[name='referrer']")['content'] = 'www.roompai.com'
      // }

      // 新打开一个页面
      // var a = document.createElement('a')
      // a.setAttribute('href', params.paymentSkipUrl)
      // a.setAttribute('target', '_blank')
      // a.setAttribute('id', 'paymentALink')
      // document.getElementById('app').appendChild(a)
      // // document.body.appendChild(a)
      // document.getElementById('paymentALink').click()

      // 当前页面跳转
      window.location.href = params.paymentSkipUrl
    }
  },
  watch: {
    language: function (newCur, oldCur) {
      // this.pageShow()
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
  },
  methods: {
    hotelLanguage (language) {
      this.language = language
    },
    waitingShow: function () {
      let locationHref = window.document.location.href
      var paymentList = document.querySelectorAll('#paymentALink')
      if (paymentList.length > 0) {
        paymentList[0].remove()
      }

      var params = this.$route.params
      var orderData = localStorage.getItem('orderData')
      if (JSON.stringify(params) === '{}' && orderData !== '{}') {
        params = JSON.parse(orderData)
      }

      var language = this.common.languageSet(this)

      var currency = this.common.currencySet(this)
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var payData = {
        'token': token,
        'hotelid': params.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'source': params.source,
        'orderno': params.orderno,
        'language': language,
        'currency': currency,
        'sessionid': sessionid,
        'operation': 'paymentOrderData',
        'time': time
      }
      var payDataJson = this.common.encryptionData(payData, this)
      orderPayment(payDataJson).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': params.source}})
          var newQuerys = this.common.linkEncode({'source': params.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': params.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '003') {
          this.frameNetworkDialog = true
        } else if (res.flag === '157') {
          // 回填数据失败
          this.frameNetworkDialog = true
        } else if (res.flag === '167') {
          // 支付失败
          this.frameNetworkDialog = true
        } else if (res.flag === '200') {
          // 当前页面跳转
          // if (params.paymentOn === 'wechat') {
          //   document.querySelector("meta[name='referrer']")['content'] = 'www.roompai.com'
          // }
          window.location.href = res.data.url

          // 新打开一个页面
          // var a = document.createElement('a')
          // a.setAttribute('href', res.data.url)
          // a.setAttribute('target', '_blank')
          // a.setAttribute('id', 'paymentALink')
          // document.getElementById('app').appendChild(a)
          // // document.body.appendChild(a)
          // document.getElementById('paymentALink').click()
        }
      })
    },
    // pingpong 支付结果
    pingpongJumpOver: function () {
      // 支付成功 请求回调接口
      // 历史信息
      var orderno = this.common.linkQuerys.orderno
      var source = this.common.linkQuerys.source
      var sessionid = this.common.linkQuerys.sessionid

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var time = parseInt(new Date().getTime() / 1000)
      if (this.conver === 1 || this.conver === '1') {
        window.location.href = '/api/orderBook?operation=paymentCallback&payType=pingpong&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + source + '&conver=' + this.conver + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=pingpong'
      } else {
        window.location.href = '/api/orderBook?operation=paymentCallback&payType=pingpong&time=' + time + '&roompaiOrderno=' + orderno + '&source=' + source + '&user_token=' + token + '&sessionid=' + sessionid + '&environment=pingpong'
      }
    }
  }
}
</script>

<style scoped>
.el-main {
    background-color: rgba(240, 242, 245, 1);
    height: 100vh;
    color: #333;
    text-align: center;
  }
.main-mobile{background-color: #FFFBE6;text-align: center;height:100vh;line-height:100vh;}
.main {
    width:50%;
    /* height: 115px; */
    /* line-height: 115px; */
    margin: 7% auto;
}
.text{
    height:45px;

}

/* .demo{
    text-align: center;
    margin-top: 100px;
    border-radius: 50%;
    margin: 0 auto;
    background-color: rgba(240, 242, 245, 1);
    width:40px;
    height:40px;
    border: 8px solid rgb(233, 236, 240);
    border-top: 8px solid rgb(121, 118, 118);
    -webkit-transform: rotate(360deg);
    animation: rotation 3s linear infinite;
    -moz-animation: rotation 3s linear infinite;
    -webkit-animation: rotation 3s linear infinite;
    -o-animation: rotation 3s linear infinite;
}

@-webkit-keyframes rotation{

    from {-webkit-transform: rotate(0deg);}

    to {-webkit-transform: rotate(360deg);}

} */
.demo img{width:150px;}
.waiting-text-one {
  height:62px;
  font-size: 24px;
  font-style: normal;
  font-weight:650;
}

.waiting-text-two{
  color:#4F4C4C;
  font-size: 18px;
  font-weight: 400;
  font-style: normal;
}

</style>



// WEBPACK FOOTER //
// src/components/order/Waiting.vue